module.exports = __webpack_public_path__ + "static/media/stars_wallpaper.30b30a4d.jpg";